import { defineColumns, EntityColumns } from '@juvare/platform-shared/features/storage';
import { z } from 'zod';
import { permissionSchema } from './Permission';

export const userEntityName = 'user';

export type UserData = z.infer<typeof userDataSchema>;
export const userDataSchema = z.object({
    email: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    permissions: z.array(permissionSchema),
});

export type UserColumns = EntityColumns<typeof userColumnsDef>;
export const userColumnsDef = defineColumns({
    email: {
        type: 'string-required',
        index: 'unique',
    },
    firstName: {
        type: 'string-required',
        index: 'partial',
    },
    lastName: {
        type: 'string-required',
        index: 'partial',
    },
    permissions: {
        type: 'string-array-required',
        index: true,
    },
});
